export default __webpack_public_path__ + "static/media/trunkclb.d6c8785f.png";